import { render, staticRenderFns } from "./ProcedureTypeList.vue?vue&type=template&id=dd2f0088&"
import script from "./ProcedureTypeList.vue?vue&type=script&lang=js&"
export * from "./ProcedureTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports